import { Component } from 'react';
import { compose } from 'ramda';
import { branch, renderComponent } from 'recompose';

import { DISPLAY_MODE } from './constants';
import SimpleGrid from './SimpleGrid';
import OverflowSlider from './OverflowSlider';
import GridPagingSlider from './GridPagingSlider';
import { withAvailableGames } from './withAvailableGames';

export const GamesView = compose(
    withAvailableGames,
    branch(
        ({ displayMode }) => displayMode === DISPLAY_MODE.SIMPLE_GRID,
        renderComponent(SimpleGrid),
        branch(
            ({ displayMode }) => displayMode === DISPLAY_MODE.SLIDER,
            renderComponent(OverflowSlider),
            renderComponent(GridPagingSlider)
        )
    )
)(Component);
